import React from 'react';

const OpenModale = ({ children, setOpen, btn = false }) => (
  <a href="#" onClick={() => setOpen(true)} className={btn ? 'btn btn-default' : ''}>
    {children}
  </a>
);

export default OpenModale;
